import {SET_SEARCH_KEY, RESET_SEARCH_KEY} from '../constants/ActionTypes';
import searchOptions from '../scripts/SearchOptions.js';

const initialState = {
    searchParams: {
        key: '',
        area: searchOptions[0].name
    },
    searchOptions: searchOptions.filter(option => !option.isFilesOnly),
    searchOptionsFiles: searchOptions.filter(option => option.isFiles || option.isFilesOnly),
};

export default function search(state = initialState, action) {
    switch (action.type) {
        case SET_SEARCH_KEY:
            return {
                ...state,
                searchParams: {...state.searchParams, key: action.params.key, area: action.params.area}
            };
        case RESET_SEARCH_KEY:
            return {
                ...state,
                searchParams: {...state.searchParams, key: '', area: searchOptions[0].name}
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/search.js